import React from 'react'
import { useSelector } from 'react-redux'
import { useFeature } from '@cbgms/base/feature-flags'
import { useEnvironmentContext } from 'contexts/EnvironmentContext'
import { IRootReducerState } from 'state/rootReducer'
import { useIsPortal } from 'utils/Subscription/PermissionSelector'
import setupDatadog, { setDatadogShopContext } from './data-dog'

const useDatadogSetup = () => {
  const isDatadogEnabled = useFeature('datadog-rum')
  const { environment } = useEnvironmentContext()
  const isPortal = useIsPortal()
  const shopId = useSelector<IRootReducerState, string>(state => state.auth.currentShop)

  React.useEffect(() => {
    if (isDatadogEnabled) {
      setupDatadog(environment, isPortal)
    }
  }, [isDatadogEnabled, environment, isPortal])

  // Declared after the init effect so it also runs once RUM has been initialised.
  React.useEffect(() => {
    if (isDatadogEnabled) {
      setDatadogShopContext(shopId)
    }
  }, [isDatadogEnabled, environment, shopId])
}

export default useDatadogSetup
